/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Does_5Inputs */

const en_bot_does_5 = /** @type {(inputs: Bot_Does_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens at most 4 pages in an isolated browser for screenshots and pages that need JavaScript. Downloads, service workers and media are switched off.`)
};

const id_bot_does_5 = /** @type {(inputs: Bot_Does_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuka maksimal 4 halaman di browser terisolasi untuk tangkapan layar dan halaman yang butuh JavaScript. Unduhan, service worker, dan media dimatikan.`)
};

/**
* | output |
* | --- |
* | "Opens at most 4 pages in an isolated browser for screenshots and pages that need JavaScript. Downloads, service workers and media are switched off." |
*
* @param {Bot_Does_5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_does_5 = /** @type {((inputs?: Bot_Does_5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Does_5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_does_5(inputs)
	return en_bot_does_5(inputs)
});